exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1fCWYIexc67io261H4sYYO{height:100%}html[dir] ._1fCWYIexc67io261H4sYYO{background-color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._1fCWYIexc67io261H4sYYO._2nKwFyB_iiJiNMJwKMPOlD{background-color:\"[theme:redDark, default:#a80000]\"}.SEpeGfdyfIKp4lHXZGcoh{height:20px;width:100%}html[dir] .SEpeGfdyfIKp4lHXZGcoh{margin:10px 0;background-color:\"[theme:neutralLight, default:#eaeaea]\"}html[dir=ltr] ._3tOi0p8hzBQCKNYk0yrSny{margin-right:8px}html[dir=rtl] ._3tOi0p8hzBQCKNYk0yrSny{margin-left:8px}._3OWu8dq8O6dpzdunrHg-5w{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
exports.locals = {
	"mailboxStorageUsed": "_1fCWYIexc67io261H4sYYO",
	"exceededQuota": "_2nKwFyB_iiJiNMJwKMPOlD",
	"usageContainer": "SEpeGfdyfIKp4lHXZGcoh",
	"icon": "_3tOi0p8hzBQCKNYk0yrSny",
	"warningText": "_3OWu8dq8O6dpzdunrHg-5w"
};